import clsx from "clsx";
import { memo } from "react";
import Icon from "@/components/icon";

export const FastForwardIndicator = memo(({ side }: { side: "left" | "right" }) => (
  <div
    className={clsx(
      "absolute top-1/2 -translate-y-1/2 pointer-events-none z-50",
      side === "left" ? "left-8" : "right-8"
    )}
  >
    <div className="relative w-16 h-16">
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="relative w-full h-full">
          <div
            className={clsx(
              "absolute inset-0 flex items-center justify-center",
              side === "left" ? "-left-10 seek-chevron-3-left" : "-right-10 seek-chevron-3-right"
            )}
          >
            <Icon name={side === "left" ? "chevron-left" : "chevron-right"} size={24} className="text-[#ffffffb3]" />
          </div>
        </div>
      </div>

      <div dir="ltr" className="absolute inset-0 flex items-center justify-center">
        {side === "left" ? (
          <span className="text-white text-sm font-bold seek-text-appear">-10</span>
        ) : (
          <span className="text-white text-sm font-bold seek-text-appear">+10</span>
        )}
      </div>
    </div>
  </div>
));

FastForwardIndicator.displayName = "FastForwardIndicator";
